import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import SignUpForm from "../forms/SignUpForm";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
}));

export default function ButtonLogIn() {
  const classes = useStyles();
  const [showForm, setShowForm] = useState(false);

  const handleClickOpen = () => {
    setShowForm(true);
  };

  const handleClose = () => {
    setShowForm(false);
  };

  return (
    <div className={classes.root}>
      <Button variant="contained" onClick={handleClickOpen} color="secondary">
        Sign Up
      </Button>
      <Dialog
        open={showForm}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Sign Up</DialogTitle>

        <DialogContent>
          <SignUpForm />
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Sign up
          </Button>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
